import ls from './localStorage'
import api from '~/api'

export const ASKED_GEO_RESPONSE = 'gofind-ASKED_GEO_RESPONSE'

export async function fetchReverseGeocode({ lat, lng }) {
  const { items } = await api.fetchReverseGeocode({ lat, lng })
  const { address } = items[0]
  const user = {
    lat,
    lng,
    city: address.city,
    state: address.state,
    stateCode: address.stateCode,
    district: address.district,
    zipCode: address.postalCode,
    country: address.countryName,
    countryCode: address.countryCode,
  }

  return user
}

export function getPermission() {
  return new Promise((resolve) => {
    try {
      if ('permissions' in window.navigator) {
        return window.navigator.permissions
          .query({
            name: 'geolocation',
          })
          .then((res) => resolve(res.state))
          .catch(() => {
            resolve('denied')
          })
      }

      const geoResponse = ls.getItem(ASKED_GEO_RESPONSE)
      return resolve(geoResponse || 'prompt')
    } catch (error) {
      return resolve('denied')
    }
  })
}

export function getPositionBrowser() {
  return new Promise((resolve, reject) => {
    window.navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        ls.setItem(ASKED_GEO_RESPONSE, 'granted')
        resolve({
          lat: latitude,
          lng: longitude,
        })
      },
      (error) => {
        ls.setItem(ASKED_GEO_RESPONSE, error.message)
        reject(error)
      },
    )
  })
}

export default {
  fetchReverseGeocode,
  getPermission,
  getPositionBrowser,
}
